import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Modal } from 'components/patterns'

export const ViewWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 5px;
  margin-bottom: 68px;
  width: auto;
  background-color: #fbfbfb;
`

export const AlertContainer = styled.div(
  (props) => `
    background-color: ${themeColor('offWhite', props)};
    padding: 16px 18px 6px;
  `
)

export const CreateTemplateWrapper = styled.div`
  padding: 25px;
`

export const CreateTemplateFooter = styled.div`
  width: 100%;
  border-top: 1px solid ${themeColor('grey')};
  position: fixed;
  bottom: 0;
  padding-top: 10px;
  margin-top: 10px;
  margin-bottom: 0px;
  background: ${themeColor('whitePrimary')};
  text-align: center;
  height: 68px;
`

export const BottomContainer = styled.div`
  margin: 0px 0px 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

export const StyledModal = styled(Modal)`
  max-width: 515px;
  top: 50%;
  transform: translateY(-50%);

  & .ant-modal-header {
    padding: 25px 25px 0;
  }
  & .ant-modal-body {
    padding: 8px 25px 25px;
  }
  & .ant-modal-footer {
    display: none;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  border: 0;
`

export const ModalMainContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding-left: 28px;
`

export const ModalContent = styled.div`
  display: flex;
`

export const ModalList = styled.ul`
  padding: 0 23px;
  margin: 12px 0 0;
`

export const ModalFooter = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 16px;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 16px;
`
